var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.375C9.86396 12.375 11.375 10.864 11.375 9C11.375 7.13604 9.86396 5.625 8 5.625C6.13604 5.625 4.625 7.13604 4.625 9C4.625 10.864 6.13604 12.375 8 12.375Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 4.57733C12.0946 4.74139 12.2633 4.91014 12.4227 5.08358L14.3422 5.3578C14.655 5.90097 14.8961 6.48237 15.0594 7.08749L13.8922 8.64139C13.8922 8.64139 13.9133 9.11952 13.8922 9.35858L15.0594 10.9125C14.8968 11.5179 14.6557 12.0994 14.3422 12.6422L12.4227 12.9164C12.4227 12.9164 12.0922 13.2609 11.9165 13.4226L11.6422 15.3422C11.0991 15.6549 10.5177 15.896 9.91255 16.0594L8.35864 14.8922C8.12005 14.9133 7.88005 14.9133 7.64146 14.8922L6.08755 16.0594C5.48217 15.8968 4.90068 15.6557 4.35786 15.3422L4.08364 13.4226C3.91021 13.2586 3.74146 13.0898 3.57739 12.9164L1.65786 12.6422C1.3451 12.099 1.10403 11.5176 0.940674 10.9125L2.10786 9.35858C2.10786 9.35858 2.08677 8.88046 2.10786 8.64139L0.940674 7.08749C1.10327 6.48211 1.34438 5.90062 1.65786 5.3578L3.57739 5.08358C3.74146 4.91014 3.91021 4.74139 4.08364 4.57733L4.35786 2.6578C4.90103 2.34504 5.48243 2.10397 6.08755 1.94061L7.64146 3.1078C7.88005 3.0867 8.12005 3.0867 8.35864 3.1078L9.91255 1.94061C10.5179 2.10321 11.0994 2.34432 11.6422 2.6578L11.9165 4.57733Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.e43128e774e11ba29fb3a0ab2a4a1894.svg";
export { ForwardRef as ReactComponent };